import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggingService } from '../../../../../../modules/src/lib/core/services/logging.service';
import { AlertContextEnum } from '../../../../../../modules/src/lib/core/enums/alert-context.enum';
import { InviteApiController } from '../../../api-controllers/invite.api-controller';
import { InviteModel } from '../../../../../../../../common/dist/angular/models/invite.model';
import { EmployeeRoleEnum } from '../../../../../../../../common/src/enums/employee-role.enum';
import { EmployeeUtils } from '../../../utils/employee.utils';
import { InviteStatusEnum } from '../../../../../../../../common/src/enums/invite-status.enum';

@Component({
  selector: 'app-employee-invite-list',
  templateUrl: './employee-invite-list.component.html',
  styleUrls: ['./employee-invite-list.component.scss'],
  standalone: false,
})
export class EmployeeInviteListComponent implements OnInit {
  alertContextEnum = AlertContextEnum;

  isLoading = true;
  showHasBeenRefreshed = true;

  invites: InviteModel[];

  statusEnum = InviteStatusEnum;

  constructor(private readonly inviteApiController: InviteApiController,
              private readonly router: Router,
              private readonly loggingService: LoggingService,
              private readonly route: ActivatedRoute) {
  }

  ngOnDestroy(): void {
  }

  async ngOnInit(): Promise<void> {
    await this.refresh();
  }

  async refresh(): Promise<void> {
    this.isLoading = true;
    this.showHasBeenRefreshed = false;

    this.invites = await this.inviteApiController.listForOrganization();
    // for (const clientQuestionnaire of this.clientQuestionnaires) {
    //   await this.clientQuestionnaireStore.save(clientQuestionnaire.id, clientQuestionnaire);
    // }

    this.isLoading = false;
    this.showHasBeenRefreshed = true;

    setTimeout(() => {
      this.showHasBeenRefreshed = false;
    }, 3000);
  }

  getRole(employeeRole: EmployeeRoleEnum): string {
    return EmployeeUtils.getEmployeeRole(employeeRole);
  }

  getStatusText(status: InviteStatusEnum): string {
    return EmployeeUtils.inviteStatusGetText(status);
  }

}
